import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const RedTerminalLanding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={65}
    height={65}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={32.5} cy={32.5} r={32.5} fill="#EF6355" fillOpacity={0.17} />
    <g transform="translate(22.5,18) scale(0.85)">
      <path
        d="M27.9429 7.12868L23.3143 6.18605V2.59225C23.3143 1.17829 22.1714 0 20.8 0H2.51429C1.14286 0 0 1.17829 0 2.59225V35.4667C0 36.8806 1.14286 38.0589 2.51429 38.0589H20.8571C22.2286 38.0589 23.3714 36.8806 23.3714 35.4667V21.3271L25.2571 21.6806C25.4286 21.7395 25.6 21.7395 25.7143 21.7395C26.8571 21.7395 27.9429 20.9147 28.1714 19.6775L30 10.1922C30.1714 8.71938 29.3143 7.36434 27.9429 7.12868ZM21.8857 35.4077C21.8857 35.9969 21.4286 36.5271 20.8 36.5271H2.51429C1.94286 36.5271 1.42857 36.0558 1.42857 35.4077V2.59225C1.42857 2.0031 1.88571 1.47287 2.51429 1.47287H20.8571C21.4286 1.47287 21.9429 1.94419 21.9429 2.59225V5.89147L11.6571 3.77054C11.0286 3.65271 10.3429 3.77054 9.77143 4.18295C9.2 4.53643 8.85714 5.12558 8.74286 5.83256L8.34286 7.83566H4.68571C3.82857 7.83566 3.08571 8.60155 3.08571 9.48527V19.2062C3.08571 20.0899 3.82857 20.8558 4.68571 20.8558H20.5714C20.6857 20.8558 20.8 20.7969 20.8571 20.7969L21.8857 21.0326V35.4077ZM7.31429 17.262C7.65714 17.8512 8.22857 18.2046 8.91429 18.3225L13.9429 19.324H4.68571C4.57143 19.324 4.51429 19.2651 4.51429 19.1473V9.48527C4.51429 9.36744 4.57143 9.30853 4.68571 9.30853H8.05714L6.91429 15.3767C6.8 16.0248 6.91429 16.6729 7.31429 17.262ZM28.5143 9.83876L26.6857 19.324C26.5714 19.9132 26 20.3256 25.4286 20.2077L9.14286 16.9085C8.85714 16.8496 8.62857 16.6729 8.45714 16.4372C8.28571 16.2015 8.22857 15.907 8.28571 15.6124L10.1143 6.12713C10.1714 5.83256 10.3429 5.5969 10.5714 5.42015C10.8 5.24341 11.0857 5.1845 11.3714 5.24341L27.7143 8.54263C28.2857 8.66046 28.6286 9.24961 28.5143 9.83876Z"
        fill="#EF6355"
      />
      <path
        d="M11.5999 11.2527L15.7142 12.0775C15.7714 12.0775 15.8285 12.0775 15.8285 12.0775C16.1714 12.0775 16.4571 11.8418 16.5142 11.4883L16.9714 9.01391C17.0285 8.83717 16.9714 8.60151 16.8571 8.48368C16.7428 8.30693 16.5714 8.1891 16.3999 8.1891L12.2857 7.3643C12.1142 7.30538 11.8857 7.3643 11.7714 7.48213C11.6571 7.59996 11.4857 7.7767 11.4857 7.95345L11.0285 10.4279C10.9714 10.6046 11.0285 10.8403 11.1428 10.9581C11.2571 11.0759 11.3714 11.1938 11.5999 11.2527ZM12.7428 8.89608L15.4857 9.42631L15.2571 10.4868L12.5714 9.89763L12.7428 8.89608Z"
        fill="#EF6355"
      />
      <path
        d="M18.5144 15.1411L11.0858 13.6683C10.6858 13.6093 10.3429 13.845 10.2287 14.2574C10.1715 14.6698 10.4001 15.0233 10.8001 15.1411L18.2287 16.614C18.2858 16.614 18.3429 16.614 18.3429 16.614C18.6858 16.614 18.9715 16.3783 19.0287 16.0248C19.1429 15.6124 18.9144 15.2 18.5144 15.1411Z"
        fill="#EF6355"
      />
      <path
        d="M22.6857 15.9659L20.5143 15.5535C20.1143 15.4946 19.7714 15.7303 19.6571 16.1427C19.6 16.5551 19.8286 16.9086 20.2286 17.0264L22.4 17.4388C22.4571 17.4388 22.5143 17.4388 22.5143 17.4388C22.8571 17.4388 23.1428 17.2031 23.2 16.8496C23.3143 16.4372 23.0286 16.0248 22.6857 15.9659Z"
        fill="#EF6355"
      />
      <path
        d="M6.97132 23.507H4.17132C3.77132 23.507 3.42847 23.8604 3.42847 24.2728C3.42847 24.6853 3.77132 25.0387 4.17132 25.0387H6.97132C7.37132 25.0387 7.71418 24.6853 7.71418 24.2728C7.71418 23.8604 7.37132 23.507 6.97132 23.507Z"
        fill="#EF6355"
      />
      <path
        d="M13.0285 23.507H10.2285C9.82845 23.507 9.4856 23.8604 9.4856 24.2728C9.4856 24.6853 9.82845 25.0387 10.2285 25.0387H13.0285C13.4285 25.0387 13.7713 24.6853 13.7713 24.2728C13.7713 23.8604 13.4285 23.507 13.0285 23.507Z"
        fill="#EF6355"
      />
      <path
        d="M19.0856 23.507H16.2856C15.8856 23.507 15.5427 23.8604 15.5427 24.2728C15.5427 24.6853 15.8856 25.0387 16.2856 25.0387H19.0856C19.4856 25.0387 19.8284 24.6853 19.8284 24.2728C19.8284 23.8604 19.4856 23.507 19.0856 23.507Z"
        fill="#EF6355"
      />
      <path
        d="M6.97132 27.631H4.17132C3.77132 27.631 3.42847 27.9845 3.42847 28.3969C3.42847 28.8093 3.77132 29.1628 4.17132 29.1628H6.97132C7.37132 29.1628 7.71418 28.8093 7.71418 28.3969C7.71418 27.9845 7.37132 27.631 6.97132 27.631Z"
        fill="#EF6355"
      />
      <path
        d="M13.0285 27.631H10.2285C9.82845 27.631 9.4856 27.9845 9.4856 28.3969C9.4856 28.8093 9.82845 29.1628 10.2285 29.1628H13.0285C13.4285 29.1628 13.7713 28.8093 13.7713 28.3969C13.7713 27.9845 13.4285 27.631 13.0285 27.631Z"
        fill="#EF6355"
      />
      <path
        d="M19.0856 27.631H16.2856C15.8856 27.631 15.5427 27.9845 15.5427 28.3969C15.5427 28.8093 15.8856 29.1628 16.2856 29.1628H19.0856C19.4856 29.1628 19.8284 28.8093 19.8284 28.3969C19.8284 27.9845 19.4856 27.631 19.0856 27.631Z"
        fill="#EF6355"
      />
      <path
        d="M6.97132 31.6962H4.17132C3.77132 31.6962 3.42847 32.0497 3.42847 32.4621C3.42847 32.8745 3.77132 33.228 4.17132 33.228H6.97132C7.37132 33.228 7.71418 32.8745 7.71418 32.4621C7.71418 32.0497 7.37132 31.6962 6.97132 31.6962Z"
        fill="#EF6355"
      />
      <path
        d="M13.0285 31.6962H10.2285C9.82845 31.6962 9.4856 32.0497 9.4856 32.4621C9.4856 32.8745 9.82845 33.228 10.2285 33.228H13.0285C13.4285 33.228 13.7713 32.8745 13.7713 32.4621C13.7713 32.0497 13.4285 31.6962 13.0285 31.6962Z"
        fill="#EF6355"
      />
      <path
        d="M19.0856 31.6962H16.2856C15.8856 31.6962 15.5427 32.0497 15.5427 32.4621C15.5427 32.8745 15.8856 33.228 16.2856 33.228H19.0856C19.4856 33.228 19.8284 32.8745 19.8284 32.4621C19.8284 32.0497 19.4856 31.6962 19.0856 31.6962Z"
        fill="#EF6355"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(RedTerminalLanding);
export default ForwardRef;
